export const banners = [
  {
    comicId: "dragon-abyss-song",
    image: "https://readdy.ai/api/search-image?query=cinematic%20anime%20key%20visual%20of%20a%20young%20swordsman%20with%20a%20glowing%20blade%20facing%20a%20distant%20mountain%20range%2C%20epic%20fantasy%20atmosphere%2C%20warm%20orange%20and%20deep%20blue%20sky%20tones%2C%20wide%20panoramic%20composition%2C%20high%20detail%20illustration&width=1600&height=720&seq=hero-banner-01&orientation=landscape",
    label: "本周强推",
    tagline: "龙渊剑歌 · 剑气所指，山河万里",
  },
  {
    comicId: "starry-sea-love",
    image: "https://readdy.ai/api/search-image?query=cinematic%20anime%20key%20visual%20of%20a%20girl%20and%20boy%20under%20a%20vast%20starry%20sky%20by%20the%20sea%2C%20romantic%20dreamy%20mood%2C%20soft%20pink%20and%20indigo%20night%20tones%2C%20wide%20panoramic%20composition%2C%20high%20detail%20illustration&width=1600&height=720&seq=hero-banner-02&orientation=landscape",
    label: "热门连载",
    tagline: "星海恋语 · 用望远镜读懂彼此的心事",
  },
  {
    comicId: "mecha-era",
    image: "https://readdy.ai/api/search-image?query=cinematic%20anime%20key%20visual%20of%20a%20giant%20mecha%20robot%20standing%20against%20a%20golden%20dusk%20wasteland%2C%20dramatic%20sense%20of%20scale%2C%20warm%20amber%20and%20steel%20gray%20tones%2C%20wide%20panoramic%20composition%2C%20high%20detail%20illustration&width=1600&height=720&seq=hero-banner-03&orientation=landscape",
    label: "新作上线",
    tagline: "机甲纪元 · 登上代号星霜的机体",
  },
  {
    comicId: "burning-high-school",
    image: "https://readdy.ai/api/search-image?query=cinematic%20anime%20key%20visual%20of%20two%20rival%20delinquent%20boys%20clashing%20fists%20at%20sunset%20on%20a%20school%20rooftop%2C%20high%20energy%20action%20mood%2C%20warm%20orange%20and%20crimson%20tones%2C%20wide%20panoramic%20composition%2C%20high%20detail%20illustration&width=1600&height=720&seq=hero-banner-04&orientation=landscape",
    label: "完结精选",
    tagline: "热血高校年代记 · 用拳头定义强大",
  },
];